var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tree-selected-none",on:{"click":function($event){$event.stopPropagation();return _vm.handleSelect.apply(null, arguments)}}},[_c('div',{staticClass:"tree-selected-inner-full"})])
}
var staticRenderFns = []

export { render, staticRenderFns }